import { ELightPath } from "./CaptureProfile";
import { EArmType } from "./Waypoint";
export interface BinningDisplayValue {
  binning: number;
  resolution: number;
  resolutionUnit: string;
}

export interface Binning {
  binningDisplayValues: BinningDisplayValue[];
  binningValues: number[];
}

export interface Gain {
  minGain: number;
  maxGain: number;
}

export interface Gamma {
  minGamma: number;
  maxGamma: number;
}

export interface Exposure {
  minExposure: number;
  maxExposure: number;
}

export interface AutoExposure{
  enable : boolean;
}

export interface SoniccExposure {
  minExposure: number;
  maxExposure: number;
  multiplier: number;
}

export interface PhotoSensor {
  id: number;
  name: string;
}

export interface Photosensor {
  photoSensors: PhotoSensor[];
}

export enum EColorFormat {
  Bayer = 0,
  Grayscale = 1,
  Color = 2,
}

export interface Camera {
  binning: Binning;
  gain?: Gain;
  gamma?: Gamma;
  exposure?: Exposure;
  soniccExposure?: SoniccExposure;
  photosensor?: Photosensor;
  colorFormat: EColorFormat;
  autoExposure?:AutoExposure;
}

export interface Brightness {
  minBrightness: number;
  maxBrightness: number;
}

export interface Condenser {
  minCondenser: number;
  maxCondenser: number;
}

export interface Polarizer {
  minPolarizer: number;
  maxPolarizer: number;
}

export interface ContinuousZoom {
  minContinuousZoom: number;
  maxContinuousZoom: number;
}

export interface Objective {
  value: number;
  name: string;
  depthOfField: number;
}

export interface ObjectiveZoom {
  objectives: Objective[];
}

export enum EFilterCube {
  Unknown = 0,
  Ultraviolet = 1,
  VisibleFluorescence = 2,
}

export interface FilterCube {
  id: number;
  name: string;
  type: EFilterCube;
}

export interface FilterCubes {
  filterCubes: FilterCube[];
}

export interface Laser {
  minLaserPower: number;
  maxLaserPower: number;
}

export interface CropZoom {
  minCropZoom: number;
  maxCropZoom: number;
}

export interface Optic {
  brightness?: Brightness;
  condenser?: Condenser;
  polarizer?: Polarizer;
  continuousZoom?: ContinuousZoom;
  objectiveZoom?: ObjectiveZoom;
  filterCubes?: FilterCubes;
  laser?: Laser;
  cropZoom?: CropZoom;
}

export interface LightPathCapability {
  lightpath: ELightPath;
  camera: Camera;
  optic: Optic;
}

export interface LightPathCollection {
  byId: { [index: number]: LightPathCapability };
  allIds: ELightPath[];
}

export interface ImagerCapability {
  identifier: string;
  supportedArmTypes: EArmType[];
  capabilities: LightPathCapability[];
  isPlateBumpSupported: boolean;
  lightpathCollection: LightPathCollection;
}
